/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

import { CognitoUserSession } from "amazon-cognito-identity-js";

export default {
  setAutoLogout(state: { didAutoLogout: boolean }): void {
    state.didAutoLogout = true;
  },
  setIDToken(state: { idToken: string }, payload: string): void {
    state.idToken = payload;
  },
  setAccessToken(state: { accessToken: string }, payload: string): void {
    state.accessToken = payload;
  },
  setUsername(state: { cognitoUserName: string }, payload: string): void {
    state.cognitoUserName = payload;
  },
  signedIn(state: { isAuthenticated: boolean }): void {
    state.isAuthenticated = true;
  },
  logout(state: { isAuthenticated: boolean }): void {
    state.isAuthenticated = false;
  },
  setIsAuthenticated(
    state: { isAuthenticated: boolean },
    payload: boolean
  ): void {
    state.isAuthenticated = payload;
  },
  setEmail(state: { email: string }, payload: string): void {
    state.email = payload;
  },
  setSession(
    state: { session: CognitoUserSession },
    payload: CognitoUserSession
  ): void {
    state.session = payload;
  },
  setGivenName(state: { givenName: string }, payload: string): void {
    state.givenName = payload;
  },
  setFamilyName(state: { familyName: string }, payload: string): void {
    state.familyName = payload;
  },
  setStationCode(state: { stationCode: string }, payload: string): void {
    state.stationCode = payload;
  },
  setLoginNumber(state: { loginNumber: number }, payload: number): void {
    state.loginNumber = payload;
  },
  setCompanyName(state: { companyName: string }, payload: string): void {
    state.companyName = payload;
  },
  setTitle(state: { title: string }, payload: string): void {
    state.title = payload;
  },
  setDepartment(state: { department: string }, payload: string): void {
    state.department = payload;
  },
  setShowPage(state: { showPage: boolean }, payload: boolean): void {
    state.showPage = payload;
  },
  setMainMenuCode(state: { mainMenuCode: string }, payload: string): void {
    state.mainMenuCode = payload;
  },
  setThreeDigitCode(state: { threeDigitCode: string }, payload: string): void {
    state.threeDigitCode = payload;
  },
  setParentCode(state: { parentCode: string }, payload: string): void {
    state.parentCode = payload;
  },
  setCountry(state: { country: string }, payload: string): void {
    state.country = payload;
  },
  setStatus(state: { status: string }, payload: string): void {
    state.status = payload;
  },
  setArea(state: { area: string }, payload: string): void {
    state.area = payload;
  },
  setId(state: { id: number }, payload: number): void {
    state.id = payload;
  },
  setDataId(state: { dataId: string }, payload: string): void {
    state.dataId = payload;
  },
  setFtpUserId(state: { ftpUserId: string }, payload: string): void {
    state.ftpUserId = payload;
  },
  setFlg(state: { Flg: boolean }, payload: boolean): void {
    state.Flg = payload;
  },
  setuserId(state: { userId: string }, payload: string): void {
    state.userId = payload;
  },
  setUserdata(state: { userdata: string }, payload: string): void {
    state.userdata = payload;
  },
  setSubExistMenu(state: { subExistMenu: any }, payload: any): void {
    state.subExistMenu = payload;
  },
  setSubMenuList(state: { subMenuList: any }, payload: any): void {
    state.subMenuList = payload;
  },
  setSubMenuItem(state: { subMenuItem: any }, payload: any): void {
    state.subMenuItem = payload;
  },
  setIsNewsFlg(state: { isNewsFlg: any }, payload: any): void {
    state.isNewsFlg = payload;
  },
  setShowPageTitle(state: { showPageTitle: string }, payload: string): void {
    state.showPageTitle = payload;
  },
  setPageClickCount(state: { pageClickCount: string }, payload: string): void {
    state.pageClickCount = payload;
  }, 
  setShowedMenuList(
    state: { showedMenuList: string },
    payload: string
  ): void {
    state.showedMenuList = payload;
  },
  setNewsData(state: { newsData: any }, payload: any): void {
    state.newsData = payload;
  },
  setChangePage(state: { changePage: any }, payload: any): void {
    state.changePage = payload;
  },
  setgroupUserId(state: { groupUserId: string }, payload: string): void {
    state.groupUserId = payload;
  },
  setgroupLName(state: { groupLName: string }, payload: string): void {
    state.groupLName = payload;
  },
  setgroupFName(state: { groupFName: string }, payload: string): void {
    state.groupFName = payload;
  },
  setgroupEmail(state: { groupEmail: string }, payload: string): void {
    state.groupEmail = payload;
  },
  setgroup(state: { group: string }, payload: string): void {
    state.group = payload;
  },
  setStationListData(state: { stationListData: any }, payload: any): void {
    state.stationListData = payload;
  },
  setSelectedStation(state: { selectedStation: any }, payload: any): void {
    state.selectedStation = payload;
  },
  setApprovalNotice(state: { approvalNotice: any }, payload: any): void {
    state.approvalNotice = payload;
  },
  setSearchedUserList(state: { searchedUserList: any }, payload: any): void {
    state.searchedUserList = payload;
  },
  setIsPageLoad(state: { isPageLoad: boolean }, payload: boolean): void {
    state.isPageLoad = payload;
  },
  setPcCompanyListData(state: { pcCompanyListData: any }, payload: any): void {
    state.pcCompanyListData = payload;
  },
  setCompanyAdminListData(state: { companyAdminListData: any }, payload: any): void {
    state.companyAdminListData = payload;
  },
  setEditSationData(state: { editStationData: any }, payload: any): void {
    state.editStationData = payload;
  },
  setFileFormatList(state: { fileFormatListData: any }, payload: any): void {
    state.fileFormatListData = payload;
  },
  setIsAltLoginAdmin(state: { isAltLoginAdmin: boolean }, payload: any): void {
    state.isAltLoginAdmin = payload;
  },
  setParamKDPSalesNoteList(state: { paramKDPSalesNoteList: any }, payload: any): void {
    state.paramKDPSalesNoteList = payload;
  },
  setKDPSalesNoteSearchData(state: { kdpSalesNoteSearchData: any }, payload: any): void {
    state.kdpSalesNoteSearchData = payload;
  },
  setKDPSalesNoteScreen(state: { kdpSalesNoteScreen: string }, payload: string): void {
    state.kdpSalesNoteScreen = payload;
  },
};
